/**
 * Сервис который принимает вход объект с данными выбранного ЦГУ
 * и выдергивает из него ID всех связанных с ним станций метро
 * и на основании этого ID генерит объект с названиями этих станций + другая информация
 */

const getMetroStations = (address, undergrounds) => {
  if (!address || !undergrounds) {
    return null;
  }

  const unfilteredMetroLocations = Array.isArray(address?.metroLocations)
    ? address?.metroLocations
    : [address.metroLocations];
  const metroLocations = unfilteredMetroLocations.filter(
    location => location.distance <= 5000
  );

  if (!metroLocations) {
    return null;
  }

  // внутри metroLocations может придти массив и объект, тут происходит проверка этого момента
  const metroStationId = metroLocations?.metroStationId;
  const distance = metroLocations?.distance;
  let metroStationIds = [{ metroStationId, distance }];

  if (!metroStationId) {
    metroStationIds = metroLocations.sort((a, b) => {
      if (a.distance > b.distance) {
        return 1;
      }
      if (a.distance < b.distance) {
        return -1;
      }
      return 0;
    });
  }

  const metroStations = metroStationIds
    .map(metroStationItem => {
      const currentMetroStation = undergrounds.filter(item =>
        item.ids.includes(`${metroStationItem.metroStationId}`)
      )[0];
      const color = currentMetroStation?.colors?.[0];
      if (!color) {
        return null;
      }
      return {
        ...currentMetroStation,
        color,
      };
    })
    .filter(metroStationItem => metroStationItem !== null);

  return metroStations;
};

export default getMetroStations;
